"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkspaceProvider = exports.useWorkspaceAssetsDispatch = exports.useWorkspaceAssets = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const workspace_store_1 = require("./workspace.store");
const WorkspaceContext = (0, react_1.createContext)(workspace_store_1.initialState);
const WorkspaceContextDispatch = (0, react_1.createContext)(() => null);
function useWorkspaceAssets() {
    return (0, react_1.useContext)(WorkspaceContext);
}
exports.useWorkspaceAssets = useWorkspaceAssets;
function useWorkspaceAssetsDispatch() {
    return (0, react_1.useContext)(WorkspaceContextDispatch);
}
exports.useWorkspaceAssetsDispatch = useWorkspaceAssetsDispatch;
function WorkspaceProvider({ children }) {
    const [state, dispatch] = (0, react_1.useReducer)(workspace_store_1.workspaceReducer, workspace_store_1.initialState);
    return ((0, jsx_runtime_1.jsx)(WorkspaceContext.Provider, { value: state, children: (0, jsx_runtime_1.jsx)(WorkspaceContextDispatch.Provider, { value: dispatch, children: children }) }));
}
exports.WorkspaceProvider = WorkspaceProvider;
//# sourceMappingURL=Workspace.context.js.map